import React, { useState, useEffect } from "react";
import * as actionType from "../../constants/actionTypes";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import decode from "jwt-decode";
import { Badge, Dropdown, Menu, Modal } from "antd";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import EditCurrentUser from "./EditCurrentUser";

const Navbar = ({ title }) => {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("profile")));
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useNavigate();

  const logout = () => {
    dispatch({ type: actionType.LOGOUT });
    history("/");
    setUser(null);
  };

  useEffect(() => {
    const token = user?.token;
    if (token) {
      const decodedToken = decode(token);
      if (decodedToken.exp * 1000 < new Date().getTime()) logout();
    }
    setUser(JSON.parse(localStorage.getItem("profile")));
  }, [location]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const items = [
    {
      key: "1",
      label: (
        <div className="cursor-auto p-2 border-b flex flex-col gap-2 items-center justify-center">
          {user?.email}
          <Badge
            count={user?.role}
            style={{ backgroundColor: "#52c41a" }}
          />
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div className="flex items-center">
          <UserOutlined className="mr-1" />
          <p onClick={() => setIsModalOpen(true)}>My profile</p>
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <div className="flex items-center">
          <LogoutOutlined className="mr-1" />
          <p onClick={logout}>Logout</p>
        </div>
      ),
    },
  ];
  return (
    <>
      <nav className="bg-white">
        <div className="flex items-center justify-between">
          <p className="m-0">{title}</p>
          <Dropdown
            menu={{ items }}
            open={visible}
            onOpenChange={(isVisible) => setVisible(isVisible)}
          >
            <p onClick={(e) => e.preventDefault()} className="m-0 mr-1">
              {user?.name} <UserOutlined />
            </p>
          </Dropdown>
        </div>
      </nav>
      <Modal
        title="Update User"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
      >
        <EditCurrentUser />
      </Modal>
    </>
  );
};

export default Navbar;
